import { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";
import {AssetDto, AssetResourceApi, BulkUploadResultDto} from "../generated/dashboard-client";

const api = new AssetResourceApi(dashboardApiConfig);

type AssetCategory = 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS';

const AssetApi = {
  list(teamId: string, category?: string, query?: string): AxiosPromise<AssetDto[]> {
    return api.list(teamId, category as AssetCategory, query, ops());
  },

  upload(teamId: string, category: string, file: File): AxiosPromise<AssetDto> {
    return api.upload(teamId, category as AssetCategory, file, ops());
  },

  bulkUpload(teamId: string, files: File[], category?: string): AxiosPromise<BulkUploadResultDto> {
    return api.uploadMultiple(teamId, files, category as AssetCategory, ops());
  },

  updateAltText(id: string, altText: string): AxiosPromise<AssetDto> {
    return api.updateAltText(id, altText, ops());
  },

  rename(id: string, name: string): AxiosPromise<AssetDto> {
    return api.renameAsset(id, name, ops());
  },

  moveCategory(id: string, category: string): AxiosPromise<AssetDto> {
    return api.moveCategory(id, category as AssetCategory, ops());
  },

  bulkMoveCategory(ids: string[], category: string): AxiosPromise<AssetDto[]> {
    return api.bulkMoveCategory(category as AssetCategory, ids, ops());
  },

  delete(id: string): AxiosPromise<void> {
    return api.deleteAsset(id, ops());
  },

  bulkDelete(ids: string[]): AxiosPromise<void> {
    return api.bulkDelete(ids, ops());
  },

  download(id: string): AxiosPromise<Blob> {
    return api.download(id, { ...ops(), responseType: "blob" });
  },

  bulkDownload(ids: string[]): AxiosPromise<Blob> {
    return api.bulkDownload(ids, { ...ops(), responseType: "blob" });
  },

  listByBrandKit(brandKitId: string, categories?: string[]): AxiosPromise<AssetDto[]> {
    return api.listByBrandKit1(brandKitId, categories as AssetCategory[] | undefined, ops());
  },

  assignToBrand(ids: string[], brandKitId: string): AxiosPromise<void> {
    return api.assignToBrand(brandKitId, ids.join(","), ops());
  },

  assignToBrands(ids: string[], brandKitIds: string[]): AxiosPromise<void> {
    return api.assignToBrands(brandKitIds.join(","), ids.join(","), ops());
  },

  unassignFromBrand(ids: string[], brandKitId: string): AxiosPromise<void> {
    return api.unassignFromBrand(brandKitId, ids.join(","), ops());
  },
};

export default AssetApi;
